import jsPDF from 'jspdf';
import { applyPlugin } from "jspdf-autotable";
import * as XLSX from 'xlsx';
import { format } from 'date-fns';
import { toast } from 'sonner';

applyPlugin(jsPDF);

const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);

export const downloadPDF = (reportData, dateRange) => {
  if (!reportData) return;
  const { start, end } = dateRange;
  const doc = new jsPDF();

  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text('Daily Accounts Report', 14, 20);

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Period: ${start} to ${end}`, 14, 28);
  doc.text(`Generated: ${format(new Date(), 'dd/MM/yyyy HH:mm')}`, 14, 34);

  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text('Summary', 14, 45);

  const summaryData = [
    ['Total Sales', formatCurrency(reportData.summary.total_sales)],
    ['Total Expenses', formatCurrency(reportData.summary.total_expenses)],
    ['Total Credits', formatCurrency(reportData.summary.total_credits)],
    ['Net Profit/Loss', formatCurrency(reportData.summary.net_profit)],
    ['Pending Payments', formatCurrency(reportData.summary.total_pending)],
    ['Total Transactions', reportData.summary.transactions_count.toString()],
  ];

  doc.autoTable({
    startY: 50,
    head: [['Metric', 'Value']],
    body: summaryData,
    theme: 'grid',
    headStyles: { fillColor: [0, 47, 167], textColor: 255 },
    styles: { font: 'helvetica', fontSize: 10 },
  });

  if (reportData.transactions.length > 0) {
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Transactions', 14, doc.lastAutoTable.finalY + 15);

    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 20,
      head: [['Date', 'Type', 'Description', 'Amount', 'Remarks']],
      body: reportData.transactions.map(t => [
        t.date, t.type.toUpperCase(), t.description, formatCurrency(t.amount), t.remarks || '-',
      ]),
      theme: 'striped',
      headStyles: { fillColor: [0, 47, 167], textColor: 255 },
      styles: { font: 'helvetica', fontSize: 8 },
      columnStyles: { 3: { halign: 'right', fontStyle: 'bold' } },
    });
  }

  doc.save(`accounts_report_${start.replace(/\//g, '-')}_to_${end.replace(/\//g, '-')}.pdf`);
  toast.success('PDF downloaded successfully');
};

export const downloadExcel = (reportData, dateRange) => {
  if (!reportData) return;
  const { start, end } = dateRange;
  const wb = XLSX.utils.book_new();

  const summaryData = [
    ['Daily Accounts Report'],
    [`Period: ${start} to ${end}`],
    [`Generated: ${format(new Date(), 'dd/MM/yyyy HH:mm')}`],
    [],
    ['Metric', 'Value'],
    ['Total Sales', reportData.summary.total_sales],
    ['Total Expenses', reportData.summary.total_expenses],
    ['Total Credits', reportData.summary.total_credits],
    ['Net Profit/Loss', reportData.summary.net_profit],
    ['Pending Payments', reportData.summary.total_pending],
    ['Total Transactions', reportData.summary.transactions_count],
  ];

  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(summaryData), 'Summary');

  if (reportData.transactions.length > 0) {
    const transactionData = reportData.transactions.map(t => ({
      Date: t.date, Type: t.type.toUpperCase(), Description: t.description,
      Amount: t.amount, Remarks: t.remarks || '-', 'Credit Type': t.credit_type || '-',
    }));
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(transactionData), 'Transactions');
  }

  XLSX.writeFile(wb, `accounts_report_${start.replace(/\//g, '-')}_to_${end.replace(/\//g, '-')}.xlsx`);
  toast.success('Excel downloaded successfully');
};
